// Profile Page Start
import Profile from "../pages/Profile/Profile";
// Profile Page End

// Admin Dashboard Page And Icons Start

// Admin Dashboard Page And Icons End

// User Dashboard Page And Icons Start
import Dashboard from "../pages/Dashboard/Dashboard";
import DashboardIcon from "./icons/DashboardIcon";
import DashboardActiveIcon from "./icons/DashboardActiveIcon";
// User Dashboard Page And Icons End

// Deals Pages And Icons Start
// import Enquiries from "../pages/Enquiries/Enquiries";
import AddDeal from "../pages/AddDeal/AddDeal";
import UpdateDeal from "./../pages/UpdateDeal/UpdateDeal";
import Deals from "../pages/Deals/Deals";
// import OpenDeals from "../pages/Deals/OpenDeals/OpenDeals";
// import WonDeals from "../pages/Deals/WonDeals/WonDeals";
// import LostDeals from "../pages/Deals/LostDeals/LostDeals";
// import TodayOpenDeals from "../pages/Deals/TodayOpenDeals/TodayOpenDeals";
// import TodayWonDeals from "../pages/Deals/TodayWonDeals/TodayWonDeals";
// import TodayLostDeals from "../pages/Deals/TodayLostDeals/TodayLostDeals";
// import MonthOpenDeals from "../pages/Deals/MonthOpenDeals/MonthOpenDeals";
// import MonthWonDeals from "../pages/Deals/MonthWonDeals/MonthWonDeals";
// import MonthLostDeals from "../pages/Deals/MonthLostDeals/MonthLostDeals";
import SafetyDividerIcon from "@mui/icons-material/SafetyDivider";
// Deals Pages And Icons End

// Properties Pages And Icons Start
import Properties from "../pages/Properties/Properties";
import AddProperties from "../pages/AddProperties/AddProperties";
import PropertiesDetails from "../pages/PropertiesDetails/PropertiesDetails";
// import PropertyDetailsTenantInfo from "../pages/PropertyDetailsTenantInfo/PropertyDetailsTenantInfo";
import PropertyIcon from "./icons/PropertiesIcon";
import PropertyActiveIcon from "./icons/PropertiesActiveIcon";
// Properties Pages And Icons End

// Leads Pages And Icons
import Leads from "../pages/Leads/Leads";
import LeadsDetails from "../pages/LeadsDetails/LeadsDetails";
import LeadsIcon from "./icons/LeadsIcon";
import LeadsActiveIcon from "./icons/LeadsActiveIcon";

// RentalManagement Pages And Icons Start
// import RentalManagement from "../pages/RentalManagement/RentalManagement";
// import RentalIcon from "./icons/RentalIcon";
// import RentalActiveIcon from "./icons/RentalActiveIcon";
// RentalManagement Pages And Icons End

// Agents Pages And Icons Start
import Agents from "../pages/Agents/Agents";
import AgentsDetails from "../pages/AgentsDetails/AgentsDetails";
import AgentsIcon from "./icons/AgentsIcon";
import AgentsActiveIcon from "./icons/AgentsActiveIcon";
// Agents Pages And Icons End

// Expense Pages And Icons Start
import Expense from "../pages/Expense/Expense";
// Expense Pages And Icons End

// Settings Pages And Icons Start
import Settings from "../pages/Settings/Settings";
// import PaymentsIcon from "./icons/PaymentIcon";
// Payments Pages And Icons End

// Payments Pages And Icons Start
// import Payments from "../pages/Payments/Payments";
import SettingsIcon from "./icons/SettingsIcon";
import SettingsActiveIcon from "./icons/SettingsActiveIcon";
// Payments Pages And Icons End

// Expense Pages And Icons Start
import ExpenseIcon from "./icons/ExpenseIcon";
import ExpenseActiveIcon from "./icons/ExpenseActiveIcon";
import AllNotifications from "../pages/AllNotifications/AllNotifications";
// import PublicPropertiesDetails from "../pages/PropertiesDetails/PublicPropertiesDetails";
import SingleStatusDeals from "../pages/Deals/SingleStatusDeals/SingleStatusDeals";
import TestPage from "../pages/testPage/testPage";
import Appointments from "../pages/Appointments/Appointments";
import MarketingListing from "../pages/Marketing/Listing/MarketingListing";
import CreateReschedule from "../pages/Marketing/CreateReschedule/CreateReschedule";
import AppointmentsIcon from "./icons/AppointmentsIcon";
import AppointmentsActiveIcon from "./icons/AppointmentsActiveIcon";
import MarketingIcon from "./icons/MarketingIcon";
import MarketingActiveIcon from "./icons/MarketingActiveIcon";
import SingleCampaign from "../pages/Marketing/SingleCampaign/SingleCampaign";
import { CreateTemplate } from "../pages/Marketing/CreateTemplate/CreateTemplate";
// import SharedPropertiesDetails from "../pages/PropertiesDetails/SharedPropertiesDetails";
// Expense Pages And Icons End

// import DashboardActiveIcon from "./icons/DashboardActiveIcon";

export const UserRoutes = [
  // User Routes
  {
    id: "profile",
    path: "/user/profile",
    title: "Profile",
    layout: "user",
    parent: false,
    component: <Profile />,
  },
  {
    id: "profile",
    path: "/user/test",
    title: "Profile",
    layout: "user",
    parent: false,
    component: <TestPage />,
  },
  {
    id: "notifications",
    path: "/user/notifications",
    title: "Notifications",
    layout: "user",
    parent: false,
    component: <AllNotifications />,
  },
  {
    id: "dashboard",
    path: "/user/dashboard",
    title: "Dashboard",
    layout: "user",
    parent: true,
    component: <Dashboard />,
    icon: <DashboardIcon />,
    activeIcon: <DashboardActiveIcon />,
  },
  // {
  //   id: "deals",
  //   path: "/user/deals",
  //   title: "Deals",
  //   layout: "user",
  //   parent: true,
  //   component: <Enquiries />,
  //   icon: <SafetyDividerIcon style={{ color: "#969ba0" }} />,
  //   activeIcon: <SafetyDividerIcon style={{ color: "white" }} />,
  // },

  {
    id: "deals",
    path: "/user/deals",
    title: "Deals",
    layout: "user",
    parent: true,
    component: <Deals />,
    icon: <SafetyDividerIcon style={{ color: "#969ba0" }} />,
    activeIcon: <SafetyDividerIcon style={{ color: "white" }} />,
  },
  {
    id: "open_deals",
    path: "/user/deals/open",
    title: "Open Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "won_deals",
    path: "/user/deals/won",
    title: "Won Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "lost_deals",
    path: "/user/deals/lost",
    title: "Lost Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "lost_deals",
    path: "/user/deals/autolost",
    title: "Lost Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "today_open_deals",
    path: "/user/deals/open/today",
    title: "Today Open Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "today_won_deals",
    path: "/user/deals/won/today",
    title: "Today Won Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "today_lost_deals",
    path: "/user/deals/lost/today",
    title: "Today Lost Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "month_open_deals",
    path: "/user/deals/open/month",
    title: "Month Open Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "month_won_deals",
    path: "/user/deals/won/month",
    title: "Month Won Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "month_lost_deals",
    path: "/user/deals/lost/month",
    title: "Month Lost Deals",
    layout: "user",
    parent: false,
    component: <SingleStatusDeals />,
  },
  {
    id: "deals_add",
    path: "/user/deals/add",
    title: "Add Deal",
    layout: "user",
    parent: false,
    component: <AddDeal />,
  },
  {
    id: "deals_update",
    path: "/user/deals/update/*",
    title: "",
    layout: "user",
    parent: false,
    component: <AddDeal />,
  },
  {
    id: "properties",
    path: "/user/properties",
    title: "Properties",
    layout: "user",
    parent: true,
    component: <Properties />,
    icon: <PropertyIcon />,
    activeIcon: <PropertyActiveIcon />,
  },
  {
    id: "properties_add",
    path: "/user/properties/add",
    title: "Add Properties",
    layout: "user",
    parent: false,
    component: <AddProperties />,
  },
  {
    id: "properties_edit",
    path: "/user/properties/edit/*",
    title: "Update Property",
    layout: "user",
    parent: false,
    component: <AddProperties />,
  },
  {
    id: "properties_details",
    path: "/user/properties/inventory/details/*",
    title: "Properties Details",
    layout: "user",
    parent: false,
    component: <PropertiesDetails />,
  },
  {
    id: "properties_details",
    path: "/user/properties/public/details/*",
    title: "Properties Details",
    layout: "user",
    parent: false,
    component: <PropertiesDetails />,
  },
  {
    id: "clients",
    path: "/user/leads",
    title: "Clients",
    layout: "user",
    parent: true,
    component: <Leads />,
    icon: <LeadsIcon />,
    activeIcon: <LeadsActiveIcon />,
  },
  {
    id: "clients_details",
    path: "/user/leads/details/*",
    title: "Clients Details",
    layout: "user",
    parent: false,
    component: <LeadsDetails />,
  },
  // {
  //   id: "leads",
  //   path: "/user/leads",
  //   title: "Clients",
  //   layout: "user",
  //   parent: false,
  //   component: <Leads />,
  //   icon: <LeadsIcon />,
  //   activeIcon: <LeadsActiveIcon />,
  // },
  // {
  //   id: "leads_details",
  //   path: "/user/leads/details/*",
  //   title: "Clients Details",
  //   layout: "user",
  //   parent: false,
  //   component: <LeadsDetails />,
  // },
  // {
  //   id: "rental_management",
  //   path: "/user/rental",
  //   title: "Rental Management",
  //   layout: "user",
  //   parent: true,
  //   component: <RentalManagement />,
  //   icon: <RentalIcon />,
  //   activeIcon: <RentalActiveIcon />,
  // },
  // {
  //   id: "rental_management_tenant_info",
  //   path: "/user/rental/tenantinfo",
  //   title: "Property Details Tenant Info",
  //   layout: "user",
  //   parent: false,
  //   component: <PropertyDetailsTenantInfo />,
  // },
  {
    id: "appointments",
    path: "/user/appointments",
    title: "Appointments",
    layout: "user",
    parent: true,
    component: <Appointments />,
    icon: <AppointmentsIcon />,
    activeIcon: <AppointmentsActiveIcon />,
  },
  {
    id: "agents",
    path: "/user/agents",
    title: "Agents",
    layout: "user",
    parent: true,
    component: <Agents />,
    icon: <AgentsIcon />,
    activeIcon: <AgentsActiveIcon />,
  },
  {
    id: "agents_details",
    path: "/user/agents/details/*",
    title: "Agent Details",
    layout: "user",
    parent: false,
    component: <AgentsDetails />,
  },
  // {
  //   id: "expense",
  //   path: "/user/expense",
  //   title: "Expense",
  //   layout: "user",
  //   parent: true,
  //   component: <Expense />,
  //   icon: <ExpenseIcon />,
  //   activeIcon: <ExpenseActiveIcon />,
  // },
  {
    id: "marketing",
    path: "/user/marketing",
    title: "Marketing",
    layout: "user",
    parent: true,
    component: <MarketingListing />,
    icon: <MarketingIcon />,
    activeIcon: <MarketingActiveIcon />,
  },

  {
    id: "create_campaign",
    path: "/user/marketing/campaign",
    title: "Create Campaign",
    layout: "user",
    parent: false,
    component: <CreateReschedule />,
  },
  {
    id: "reschedule_campaign",
    path: "/user/marketing/details/*",
    title: "Reschedule Campaign",
    layout: "user",
    parent: false,
    component: <SingleCampaign />,
  },
  {
    id: "create_template",
    path: "/user/marketing/template",
    title: "Create Template",
    layout: "user",
    parent: false,
    component: <CreateTemplate />,
  },
  {
    id: "reschedule_campaign",
    path: "/user/marketing/campaign/reschedule/*",
    title: "Reschedule Campaign",
    layout: "user",
    parent: false,
    component: <CreateReschedule />,
  },
  {
    id: "settings",
    path: "/user/settings",
    title: "Settings",
    layout: "user",
    parent: true,
    component: <Settings />,
    icon: <SettingsIcon />,
    activeIcon: <SettingsActiveIcon />,
  },

  // {
  //   id: "payments",
  //   path: "/user/payments",
  //   title: "Payments",
  //   layout: "user",
  //   parent: true,
  //   component: <Payments />,
  //   icon: <PaymentsIcon />,
  //   activeIcon: <PaymentsIcon />,
  // },
];
